import {Alert, Box} from '@mui/material';
import {TFunction} from 'i18next';

export default function MutationStatusIndicator({
  mutationStatus,
  error,
  t
}: {
  mutationStatus: 'error' | 'idle' | 'loading' | 'success';
  error: string;
  t: TFunction;
}) {
  if (mutationStatus !== 'error') {
    return null;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        mt: 1
      }}
    >
      <Alert sx={{width: '100%'}} severity="error">
        {error === 'isDermatologyDomain'
          ? t('ui:diagnosticReport.imageError.cardSubheaderHeader.isDermatological')
          : t('ui:diagnosticReport.imageError.cardSubheaderHeader.qualityAcceptable')}
      </Alert>
    </Box>
  );
}
